export default {"src":"/_next/static/media/water-resistance-icon-no.30af6122.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};